<template>
	<div class="link">
		<el-link type="primary" @click="reOnClick">
		<!-- <el-button type="primary" size="small" @click="reOnClick()">返回</el-button> -->
			<svg class="icon"  aria-hidden="true">
							<use xlink:href="#icon-fanhui-"></use>
			</svg>
			<span>返回</span>
		</el-link>
	</div>
	</template>
	<script>
		export default {
			  name: "link",
			  methods:{
          reOnClick(){
            this.$emit('reOnClick');
          }
        }

			}
	</script>
	<style scoped="scoped">
		.link .icon {
    font-size: 15px;
    color: #409eff;
    margin-right: 7px;
}
.el-link span{
	font-size: 12px;
}
	</style>
